import React from 'react';
import { highlightCoefChanges } from '~/web-frontend-components/line/outcomes/additional/tables/Td';
const CoefTd = React.memo((props) => {
    if (props.isDisabled) {
        return <Td cell={props.cell} cf={props.cf}/>;
    }
    return (<div className={`live__item__game-bet ${props.isChoosen ? 'selected' : 'unselected'} ${props.cell.st} ${props.cell.additionalClassName || ''} ${props.light}`} onClick={() => { props.cfID && props.onClick(props.cfID, props.matchID); }}>
         <span className='live__item__game-bets-odd'>{props.cell.txt}</span>
         <span className='live__item-bet'>{props.cf}</span>
      </div>);
});
const Td = React.memo((props) => <div className='live__item__game-bet disabled'>
      <span className='live__item__game-bets-odd'>{props.cell.txt}</span>
      <span className='live__item-bet'>{props.cf}</span>
   </div>);
const HightlightCoefTd = highlightCoefChanges(CoefTd);
export { HightlightCoefTd, Td };



// WEBPACK FOOTER //
// ./src/web-frontend-components/line/outcomes.mobile/additional/tables/Td.mobile.jsx